
import { UnidAdm } from "./agro.unid.adm.model";
import { UserDTO } from "./agro.user-dto.model";
import { PermissoesDTO } from "./agro.permissao.model";

/**
 * Modelo Padrão de Usuário Logado.
 */
export class UserAuthModel {

    user: UserDTO;
    locale: string;
    unidAdm: UnidAdm;
    permissoes?: Map<string, Array<PermissoesDTO>>;
    applications?: Array<PermissoesDTO>;

    constructor() { };
}